import React from 'react';
import VideosState from './videosState/VideosState';
import VideosControlPanel from './components/VideosControlPanel/VideosControlPanel';
import Videos from './components/Videos/Videos';
import { ModalWindows } from './components/ModalWindows/ModalWindows';
import style from './index.module.scss';

const VideosPage: React.FC = () => {
	return (
		<VideosState>
			<div className={style.container} data-test="VideosPage">
				<VideosControlPanel />
				<Videos />
				<ModalWindows />
			</div>
		</VideosState>
	);
};

export default VideosPage;
